module.exports = __webpack_public_path__ + "img/zuijia_22.c1d01791.png";